export const LOCATION_UPDATED = '@@mah-maps/LOCATION_UPDATED';
export const COUNTRY_OBTAINED = '@@mah-maps/COUNTRY_OBTAINED';